import React from 'react'
import { styled } from '@mui/material/styles'

import AppBar from '../organisms/AppBar'

const classes = {
  appContainer: 'app-container',
}
const AppWrapper = styled('div')(({ theme }) => ({
  [`& .${classes.appContainer}`]: {
    backgroundColor: theme.custom.bodyColor,
    // minHeight: '100vh',
    // display: 'flex',
    // width: '100%',
    // marginTop: '80px',
  },
}))

const MainTemplate = ({ children }) => {
  return (
    <AppWrapper>
      <div className={classes.appContainer}>
        <AppBar />
        {children}
      </div>
    </AppWrapper>
  )
}
export default MainTemplate
